import React from 'react';
const FormActions = (props) => {
    return <div className="control-column">{props.children}</div>
}
export default FormActions